import { getClientConfig } from 'app-components/utils/core';

// Staging Amplify app that hosts PR previews (see scripts/amplify_manual_deploy.sh).
const previewSuffix = '.d30hv3oesima27.amplifyapp.com';
// Amplify previews have no host entry, so they resolve to staging and only redeem staging tokens.
const previewEnvironment = 'stg';

// The sender mints in the environment previews redeem against.
export function getPreviewEnvironment(): string | undefined {
  return getClientConfig()?.environment === previewEnvironment ? previewEnvironment : undefined;
}

// Returns the canonical preview origin, or undefined if the host is not a preview branch.
export function parsePreviewTarget(raw: string | null): string | undefined {
  try {
    const host = new URL(raw ?? '').hostname.toLowerCase();
    const label = host.endsWith(previewSuffix) ? host.slice(0, -previewSuffix.length) : '';
    return /^[a-z0-9-]+$/.test(label) ? `https://${host}` : undefined;
  } catch {
    return undefined;
  }
}

// The staging sender link that signs the given preview in, or undefined if it is not a preview host.
// Matches the "Sign in via staging" link in packages/ci/src/validation/post-preview-comments.mjs.
export function getPreviewSignInUrl(origin: string = window.location.origin): string | undefined {
  const target = parsePreviewTarget(origin);
  return target && `https://simplifi-stg.quickencs.com/dev-sso?preview=${encodeURIComponent(target)}`;
}
